module.exports = __webpack_public_path__ + "img/IMG_20190603_144625.557e3952.jpg";